<template>
  <div id="app">
    <SiteHeader v-if="!$route.meta.hideHeaderFooter" />
    <router-view/>
    <SiteFooter v-if="!$route.meta.hideHeaderFooter" />

    <!-- Login Register Pop Up -->
    <AuthModal />
    <VideoPlayer />
  </div>
</template>
<script>
import SiteHeader from './components/SiteHeader.vue';
import SiteFooter from './components/SiteFooter.vue';
export default {
  components:{
    SiteHeader,
    SiteFooter,
    // These two are mounted on every page (no v-if) but are only ever
    // interacted with on some visits - AuthModal pulls in the full
    // Login/Register/ForgotPassword forms, and VideoPlayer pulls in dashjs
    // (the DASH streaming library) via DashVideo.vue. Loading them as async
    // components moves that weight out of the main bundle and into their
    // own chunks, so they no longer add to the JS every page has to parse
    // before it can render.
    AuthModal: () => import('./components/AuthModal.vue'),
    VideoPlayer: () => import('./components/VideoPlayer.vue'),
  }
}
</script>
<style>
#app {
  font-family: 'Poppins', sans-serif;
}
</style>
